import { Divider, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY, MARTIAL_STATUSES } from 'Enum';
import { useAppSelector, useDictionary, useIsDesktop } from 'Hooks';
import { AccordionSection } from '../AccordionSection';
import { useFormContext } from 'react-hook-form';
import { DatePickerInput } from 'Components/HookFormInputs/DatePickerInput';
import { TextInput } from 'Components/HookFormInputs/TextInput';
import { ToggleButtons } from 'Components/HookFormInputs/ToggleButtons';
import { sanitizeLettersNumbersAndSpacialChars } from 'Utils/sanitizeLettersNumbersAndSpacialChars';
import { sanitizeNumbersLength } from 'Utils/sanitizeNumbers';
import { ResetButton } from '../ResetButton';
import { useParams } from 'react-router-dom';
import { CustomFieldset } from 'Components';
import { SelectInput } from 'Components/HookFormInputs/SelectInput';
import { SimpleToggle } from 'Components/SimpleToggle';

export const MaritalStatus = () => {
  const {
    register,
    formState: { errors, defaultValues },
    watch,
    reset,
  } = useFormContext();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.UpdatePersonalDetails
  ).maritalStatus;

  const generalOptions = useAppSelector(
    (generalOptions) => generalOptions.generalOptions.generalOptions
  );
  const isDesktop = useIsDesktop();
  const params = useParams();

  return (
    <AccordionSection
      defaultExpanded={params.sectionId === '2'}
      title={dictionary.title}
      subtitle={dictionary.subtitle}
    >
      <Stack alignItems={'center'}>
        <Stack maxWidth={isDesktop ? '400px' : 'initial'} gap='20px'>
          <CustomFieldset>
            <SelectInput
              value={watch('status')}
              label={dictionary.inputLabel1}
              options={
                generalOptions?.general?.maritalStatuses.filter(
                  (status) => status.id !== MARTIAL_STATUSES.bachelor
                ) || []
              }
              register={register('status')}
              error={!!(errors as any)?.status}
              defaultOptionId={defaultValues?.status}
              height={isDesktop ? '48px' : '42px'}
            />
            <DatePickerInput
              label={dictionary.inputLabel2}
              maxDate={new Date(Date.now())}
              minDate={new Date(watch('spouse.birthDate'))}
              registerName={'lastUpdatedDate'}
              maxWidth='400px'
            />
          </CustomFieldset>
          <CustomFieldset>
            <Typography
              alignSelf='flex-start'
              component='legend'
              display='block'
              mb={isDesktop ? '16px' : '10px'}
            >
              {dictionary.spouseDetails.title}
            </Typography>
            <legend>{dictionary.spouseDetails.title}</legend>
            <TextInput
              label={dictionary.spouseDetails.inputLabel1}
              register={register('spouse.identityNumber', {
                onChange: (e) => sanitizeNumbersLength(e, 9),
              })}
              errors={(errors as any)?.spouse?.identityNumber}
              shrink={(watch('spouse.identityNumber') || '')?.length > 0}
              isNumbersOnly={true}
            />
            <TextInput
              label={dictionary.spouseDetails.inputLabel2}
              register={register('spouse.firstName', {
                onChange: (e) => sanitizeLettersNumbersAndSpacialChars(e, 20),
              })}
              errors={(errors as any)?.spouse?.firstName}
              shrink={(watch('spouse.firstName') || '')?.length > 0}
            />
            <TextInput
              label={dictionary.spouseDetails.inputLabel3}
              register={register('spouse.lastName', {
                onChange: (e) => sanitizeLettersNumbersAndSpacialChars(e, 40),
              })}
              errors={(errors as any)?.spouse?.lastName}
              shrink={(watch('spouse.lastName') || '')?.length > 0}
            />
            <DatePickerInput
              label={dictionary.spouseDetails.inputLabel4}
              maxDate={new Date(watch('lastUpdatedDate') || Date.now())}
              registerName={'spouse.birthDate'}
              maxWidth='400px'
            />
          </CustomFieldset>
          <CustomFieldset>
            <Typography
              alignSelf='flex-start'
              component='legend'
              display='block'
              mb={isDesktop ? '16px' : '10px'}
            >
              {dictionary.spouseDetails.inputLabel5}
            </Typography>
            <ToggleButtons
              option1={{
                id: generalOptions?.general?.genders[0]?.id || 0,
                value: generalOptions?.general?.genders[0]?.value || '0',
              }}
              option2={{
                id: generalOptions?.general?.genders[1]?.id || 1,
                value: generalOptions?.general?.genders[1]?.value || '1',
              }}
              registerName='spouse.gender'
            />
          </CustomFieldset>
          <ResetButton
            onClick={() => reset(defaultValues)}
            resetCategoryAriaText={dictionary.reset}
          />
        </Stack>
      </Stack>
    </AccordionSection>
  );
};
